import React, {Component} from "react";
import MobileShiftPlanningDataForm from "./mobileShiftPlanningDataForm";
import Input from "../../common/input";
import {get as getShiftPlanningExt} from "../../../services/http/shiftPlanningExtService";
import {deleteWithJWT, getApiUrl, postWithJWT,} from "../../../services/http/httpService";
import {dateToString, stringToDate} from "../../../services/dateTimeFormat";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileShiftPlanningListForm extends Component {
    state = {
        dataList: [],
        headerList: [],
        startDate: "20200601",
        endDate: "20200607",
        data: {},
        showModal: false,
        startActionDate: "",
        endActionDate: "",
    };

    days = 0;

    absenceList = [];
    absenceId = 0;
    timeTimeModelList = [];
    timeTimeModelId = 0;
    selectedPerson = {
        id: 0,
        surname: ""
    };

    componentDidMount = async () => {
        const {startDate, endDate} = this.state;
        await this.onRefresh(startDate, endDate);
    };

    onRefresh = async (startDate, endDate) => {
        const request = await getShiftPlanningExt(
            this.props.credentials,
            getApiUrl() +
            "/" +
            "secClockworkShiftPlanningExt?startDate=" +
            startDate +
            "&endDate=" +
            endDate
        );

        this.days = request.data.data.days;
        this.createDataList(
            request.data.data.headerList,
            request.data.data.dataList,
            startDate,
            endDate
        );
    };

    onSelectPersons = async () => {
        alert("Dieser Browser ist für diesen Entwicklungsmodus nicht zugelassen!")
    };

    onShowError = async (personId, date, message) => {
        alert(message);
    };

    onChangeData = async (cellData) => {

        this.setState({startActionDate: cellData.d, endActionDate: cellData.d});
        this.selectedPerson.id = cellData.pId;
        this.selectedPerson.surname = cellData.n;
        const request = await getShiftPlanningExt(
            this.props.credentials,
            getApiUrl() +
            "/" +
            "secClockworkAbsenceAndTimeTimeModel?personId=" +
            cellData.pId
        );

        this.absenceList = []
        this.absenceId = cellData.aId
        this.timeTimeModelList = []
        this.timeTimeModelId = cellData.tId


        for (const absence of request.data.data.absenceList) {
            this.absenceList.push(
                {
                    dbId: absence.dbId,
                    name: absence.description
                }
            );
        }
        for (const timeTimeModel of request.data.data.timeTimeModelList) {
            this.timeTimeModelList.push(
                {
                    dbId: timeTimeModel.dbId,
                    name: timeTimeModel.description,
                }
            );
        }

        this.onOpenModal();
    };

    onChangeAbsence = ({currentTarget: input}) => {
        // console.log("MobileShiftPlanningListForm.onChangeAbsence() dbId=", dbId)
        // console.log("MobileShiftPlanningListForm.onChangeAbsence() dbId.currentTarget=", dbId.currentTarget)
        // console.log("MobileShiftPlanningListForm.onChangeAbsence() dbId.target.value=", dbId.target.values)
        this.absenceId = input.value;
        this.setState({})
    }
    onChangeTimeTimeModel = ({currentTarget: input}) => {
        this.timeTimeModelId = input.value;
        this.setState({})
    }

    onChangeStartDate = ({currentTarget: input}) => {
        const {endDate} = this.state;
        // this.setState({ startDate: input.value });
        this.onRefresh(
            dateToString(stringToDate(input.value, "YYYY-MM-DD"), "YYYYMMDD"),
            endDate
        );
    };

    onChangeEndDate = ({currentTarget: input}) => {
        const {startDate} = this.state;
        // this.setState({ endDate: input.value });
        this.onRefresh(
            startDate,
            dateToString(stringToDate(input.value, "YYYY-MM-DD"), "YYYYMMDD")
        );
    };

    onChangeStartActionDate = ({currentTarget: input}) => {
        this.setState({
            startActionDate: dateToString(
                stringToDate(input.value, "YYYY-MM-DD"),
                "YYYYMMDD"
            ),
        });
    };

    onChangeEndActionDate = ({currentTarget: input}) => {
        this.setState({
            endActionDate: dateToString(
                stringToDate(input.value, "YYYY-MM-DD"),
                "YYYYMMDD"
            ),
        });
    };

    onSaveAbsence = async () => {
        const {selectedPerson, absenceId} = this;
        const {startDate, endDate, startActionDate, endActionDate} = this.state;
        const request = await postWithJWT(
            this.props.credentials,
            getApiUrl() + "/secClockworkAbsencePlanning",
            {
                personId: selectedPerson.id,
                absenceId: absenceId,
                startDate: startActionDate,
                endDate: endActionDate,
            }
        );
        this.onRefresh(startDate, endDate)
    };

    onDeleteAbsence = async () => {
        const {selectedPerson, absenceId} = this;
        const {startDate, endDate, startActionDate, endActionDate} = this.state;
        const request = await deleteWithJWT(
            this.props.credentials,
            getApiUrl() + "/secClockworkAbsencePlanning" + "?" +
            "personId=" + selectedPerson.id + "&" +
            "absenceId=" + absenceId + "&" +
            "startDate=" + startActionDate + "&" +
            "endDate=" + endActionDate
        );
        this.onRefresh(startDate, endDate)
    };

    onSaveTimeTimeModel = async () => {
        const {selectedPerson, timeTimeModelId} = this;
        const {startDate, endDate, startActionDate, endActionDate} = this.state;
        const request = await postWithJWT(
            this.props.credentials,
            getApiUrl() + "/secClockworkShiftPlanning",
            {
                personId: selectedPerson.id,
                timeTimeModelId: timeTimeModelId,
                startDate: startActionDate,
                endDate: endActionDate,
            }
        );
        this.onRefresh(startDate, endDate)
    };

    onDeleteTimeTimeModel = async () => {
        const {selectedPerson, timeTimeModelId} = this;
        const {startDate, endDate, startActionDate, endActionDate} = this.state;
        const request = await deleteWithJWT(
            this.props.credentials,
            getApiUrl() + "/secClockworkShiftPlanning" + "?" +
            "personId=" + selectedPerson.id + "&" +
            "timeTimeModelId=" + timeTimeModelId + "&" +
            "startDate=" + startActionDate + "&" +
            "endDate=" + endActionDate
        );
        this.onRefresh(startDate, endDate)
    };

    createDataList = (recordHeaderList, recordDataList, startDate, endDate) => {
        const headerList = [...recordHeaderList];
        const dataList = [];

        for (const record of recordDataList) {
            const row = {};
            if (record.department) {
                row["name"] = record.department.description + " (" + record.department.number + ")";
                row["type"] = "department";
                this.setDay(row, record.department);
            } else if (record.costUnit) {
                row["name"] = record.costUnit.description + " (" + record.costUnit.number + ")";
                row["type"] = "costUnit";
                this.setDay(row, record.costUnit);
            } else if (record.timeTimeModel) {
                row["name"] = record.timeTimeModel.number;
                row["type"] = "timeTimeModel";
                this.setDay(row, record.timeTimeModel);
            } else if (record.absence) {
                row["name"] = record.absence.description;
                row["type"] = "absence";
                this.setDay(row, record.absence);
            } else if (record.unused) {
                row["name"] = record.unused.description;
                row["type"] = "unused";
                this.setDay(row, record.unused);
            } else if (record.person) {
                row["name"] = "";
                row["type"] = "person";
                this.setDay(row, record.person);
            }

            dataList.push(row);
        }

        this.setState({headerList, dataList, startDate, endDate, showModal: false});
    };

    setDay = (row, dayRecords) => {
        const {days} = this;
        for (let i = 1; i <= days; i++) {
            if (dayRecords[`d${i}`]) row[`${i}`] = dayRecords[`d${i}`];
        }
    };

    renderHeader = (headerList, day) => {
        if ((!headerList || !day || day <= 0, headerList.length <= 0))
            return <React.Fragment></React.Fragment>;

        const header = headerList[day - 1];
        if (!header) return <React.Fragment></React.Fragment>;

        return (
            <React.Fragment>
                <div>{header.t1 ? header.t1 : ""}</div>
                <div>{header.t2 ? header.t2 : ""}</div>
            </React.Fragment>
        );
    };

    renderName = (cellInfo) => {
        switch (cellInfo.row._original.type) {
            case "department":
                return <h5>
                    {cellInfo.row._original.name}
                </h5>;
                break;
            case "costUnit":
                return <h6>
                    {cellInfo.row._original.name}
                </h6>;
                break;
            default:
                return <div>
                    {cellInfo.row._original.name}
                </div>;
        }
    };

    renderCell = (cellInfo, day) => {
        if (!day || day < 1) return "";

        const cellData = cellInfo.row._original[`${day}`];
        if (cellData === undefined || cellData === null || !cellData) return "";

        switch (cellInfo.row._original.type) {
            case "department":
            case "costUnit":
            case "timeTimeModel":
            case "absence":
            case "unused":
                return cellData.c ? (
                    <React.Fragment>
                        <div
                            style={{
                                textAlign: "center",
                            }}
                        >
                            <p>{cellData.c}</p>
                        </div>
                    </React.Fragment>
                ) : (
                    ""
                );
            default:
                if (cellData.warning) {
                    return this.renderWarningButton(cellData);
                }
                return this.renderPersonButton(cellData);
        }
    };

    renderWarningButton = (cellData) => {
        return (
            <React.Fragment>
                <div className="btn-group-horizontal">
                    <div className="btn-group mr-2" role="group" aria-label="First group">
                        <div
                            style={{
                                textAlign: "center",
                                backgroundColor: "cellData.c",
                            }}
                        >
                            <button
                                className="btn btn-danger btn-sm"
                                value={"warning"}
                                onClick={() => {
                                    this.onShowError(cellData.pid, cellData.d, cellData.message);
                                }}
                            >
                                {"i"}
                            </button>
                        </div>
                        <div
                            style={{
                                textAlign: "center",
                                backgroundColor: cellData.c,
                            }}
                        >
                            <button
                                className="btn btn-light btn-sm"
                                value={"warning"}
                                onClick={() => {
                                    this.onChangeData(cellData);
                                }}
                            >
                                {cellData.n}
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };
    renderPersonButton = (cellData) => {
        return (
            <div
                style={{
                    textAlign: "center",
                    backgroundColor: cellData.c,
                }}
            >
                <button
                    className="btn btn-light btn-sm"
                    value={"warning"}
                    onClick={() => {
                        this.onChangeData(cellData);
                    }}
                >
                    {cellData.n}
                </button>
            </div>
        );
    };

    onOpenModal = (absenceId, timeTimeModelId) => {
        this.setState({showModal: true});
    };

    onCloseModal = () => {
        this.setState({showModal: false});
    };

    MODAL_STYLES = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, .5)",
        },
        content: {
            position: "absolute",
            top: "40px",
            left: "40px",
            right: "40px",
            height: "600px",
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "show",
            WebkitOverflowScrolling: "touch",
            borderRadius: "4px",
            outline: "none",
            padding: "20px",
        },
    };

    render = () => {
        const {
            headerList,
            dataList,
            startDate,
            endDate,
            showModal,
            startActionDate,
            endActionDate,
        } = this.state;
        const {
            days,
            MODAL_STYLES,
            onSaveAbsence,
            onDeleteAbsence,
            onSaveTimeTimeModel,
            onDeleteTimeTimeModel,
            onCloseModal,
            onChangeAbsence,
            onChangeTimeTimeModel,
            onChangeStartActionDate,
            onChangeEndActionDate,
            selectedPerson,
            absenceList,
            absenceId,
            timeTimeModelList,
            timeTimeModelId
        } = this;
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const thStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    // fontSize: "x-small",
                    padding: "2px 2px",
                    margin: "0"
                    //          height: "30px"
                }
            };
        };
        const tdStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    // fontSize: "x-small",
                    padding: "2px 2px",
                    margin: "0",
                    background: rowInfo.row._original.type === "department" ? "lightsalmon" :
                        (rowInfo.row._original.type === "costUnit" ? "lightyellow" :
                            (rowInfo.row._original.type === "timeTimeModel" ? "lightgreen" :
                                (rowInfo.row._original.type === "absence" ? "lightcoral" :
                                    (rowInfo.row._original.type === "unused" ? "lightblue" : ""))))
                }
            }
        };

        columns.push({
            Header: (
                <React.Fragment>
                    <div
                        className="btn-toolbar"
                        role="toolbar"
                        aria-label="Toolbar with button groups"
                    >
                        <div className="btn-group-horizontal">
                            <div
                                className="btn-group mr-2"
                                role="group"
                                aria-label="First group"
                            >
                                <Input
                                    name={"startDate"}
                                    label={"von"}
                                    value={dateToString(
                                        stringToDate(startDate, "YYYYMMDD"),
                                        "YYYY-MM-DD"
                                    )}
                                    type={"date"}
                                    onChange={this.onChangeStartDate}
                                />
                                <Input
                                    name={"endDate"}
                                    label={"bis"}
                                    value={dateToString(
                                        stringToDate(endDate, "YYYYMMDD"),
                                        "YYYY-MM-DD"
                                    )}
                                    type={"date"}
                                    onChange={this.onChangeEndDate}
                                />
                            </div>
                            <div
                                className="btn-group mr-2"
                                role="group"
                                aria-label="Second group"
                            >
                                <button
                                    className="btn btn-info"
                                    value={"aktualisieren"}
                                    onClick={() => {
                                        this.onRefresh(startDate, endDate);
                                    }}
                                >
                                    {"aktualisieren"}
                                </button>
                            </div>
                            <div
                                className="btn-group mr-2"
                                role="group"
                                aria-label="Second group"
                            >
                                <button
                                    className="btn btn-info"
                                    value={"Personenauswahl"}
                                    onClick={() => {
                                        this.onSelectPersons();
                                    }}
                                >
                                    {"Personenauswahl"}
                                </button>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ),
            // fixed: "left",
            columns: [],
        });

        columns[0].columns.push({
            Header: "Name",
            accessor: "name",
            // fixed: "left",
            Cell: (cellInfo) => this.renderName(cellInfo)
            , style: {
                'whiteSpace': 'unset'
            }
        });
        for (let i = 1; i <= days; i++) {
            columns[0].columns.push({
                Header: this.renderHeader(headerList, i),
                accessor: `${i}`,
                Cell: (cellInfo) => this.renderCell(cellInfo, i)
            });
        }

        return (
            <React.Fragment>
                <MobileShiftPlanningDataForm
                    showModal={showModal}
                    contentLabel="MobileShiftPlanningDataForm"
                    style={MODAL_STYLES}
                    ariaHideApp={false}
                    startActionDate={startActionDate}
                    endActionDate={endActionDate}
                    handleCloseModal={onCloseModal}
                    handleSaveAbsence={onSaveAbsence}
                    handleDeleteAbsence={onDeleteAbsence}
                    handleSaveTimeTimeModel={onSaveTimeTimeModel}
                    handleDeleteTimeTimeModel={onDeleteTimeTimeModel}
                    handleChangeAbsence={onChangeAbsence}
                    handleChangeTimeTimeModel={onChangeTimeTimeModel}
                    handleChangeStartActionDate={onChangeStartActionDate}
                    handleChangeEndActionDate={onChangeEndActionDate}
                    person={selectedPerson}
                    absenceList={absenceList}
                    absenceId={absenceId}
                    timeTimeModelList={timeTimeModelList}
                    timeTimeModelId={timeTimeModelId}
                />
                {!showModal && (
                    <ReactTableFixedColumns
                        columns={columns}
                        data={dataList}
                        defaultPageSize={dataList.length}
                        showPagination={false}
                        getTheadThProps={thStyle}
                        // getTrProps={trStyle}
                        getTdProps={tdStyle}
                        style={{height: window.innerHeight}}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default MobileShiftPlanningListForm;
